import React, { useContext, useState } from "react";
import { Context } from "../../../../store/AppContext.js";
import "../../../../../styles/TablaClientes.css";
import PanelInformativoDt from "./PanelInformativoDt.js";
import { calcularSaldoDtProvidencia } from "../../calcularSaldoDtProvidencia";

const ListaClientesDtCompleta = ({
	setClienteSeleccionado,
	setClienteDtCliqueado,
	colores,
	tipoFiltro,
}) => {
	const { store, actions } = useContext(Context);
	const array = new Map();
	const [panel, setPanel] = useState(false);

	const HandlerSaldo = () => {
		setPanel(true);

		setTimeout(() => {
			setPanel(false);
		}, 10000);
	};

	const HandlerClick = (object, event) => {
		if (event.target.className != "telefono") {
			setClienteDtCliqueado(object);
			setClienteSeleccionado(true);
		}
	};

	//Funciones para el Saldo - Simplificada para DtProvidencia
	const CalculoSaldo = (objeto, meses) => {
		const { saldo } = calcularSaldoDtProvidencia(objeto);
		return saldo;
	};

	const Filtro = (objeto) => {
		// Esta función permite Filtrar el Listado de Clientes, por tipo Filtro.
		const saldo = CalculoSaldo(objeto, false);
		
		if (tipoFiltro === "Todo") {
			return objeto;
		} else if (tipoFiltro === "Con Deuda") {
			// Mostrar clientes con saldo mayor a 0 (no "Pagado" ni 0)
			return saldo !== "Pagado" && saldo > 0;
		} else if (tipoFiltro === "Sin Deuda") {
			// Mostrar clientes sin deuda (saldo "Pagado" o 0)
			return saldo === "Pagado" || saldo === 0;
		} else if (tipoFiltro === "Vigente") {
			return objeto.vigente === "Si";
		} else if (tipoFiltro === "No Vigente") {
			return objeto.vigente === "No";
		} else if (tipoFiltro === "Con DICOM") {
			return objeto.dicom === "Si";
		} else if (tipoFiltro === "Sin DICOM") {
			return objeto.dicom === "No";
		} else if (tipoFiltro === "Con Patente") {
			return objeto.patente === "Si";
		} else if (tipoFiltro === "Sin Patente") {
			return objeto.patente === "No";
		} else if (tipoFiltro === "Contrato Actualizado") {
			return objeto.contratoActualizado === "Si";
		} else if (tipoFiltro === "Contrato No Actualizado") {
			return objeto.contratoActualizado === "No";
		}
	};

	// Funciones para los Colores
	const Colores = (objeto) => {
		if (colores === true) {
			if (objeto.p === "Si") {
				return "aqua";
			}
			if (objeto.vigente === "No") {
				return "red";
			}
			if (
				objeto.vigente === "Si" &&
				(CalculoSaldo(objeto, false) === 0 ||
					CalculoSaldo(objeto, false) === "Pagado")
			) {
				return "lawnGreen";
			}
		}
	};

	//La siguiente funcion despliega la lista de Clientes con sus respectivas Columnas.
	const ListaDesplegarClientes = (objeto, i) => {
		return (
			<tr
				className='trVistaAmpliada'
				key={i}
				onClick={(e) => HandlerClick(objeto, e)}
				style={colores ? { backgroundColor: Colores(objeto) } : null}
			>
				<td>{objeto.id}</td>
				<td>{objeto.razon}</td>
				<td>{objeto.rut}</td>
				<td>
					{objeto.correo}
					{objeto.correoSecundario === "" ? null : (
						<span>, {objeto.correoSecundario}</span>
					)}
					{objeto.correoTerciario === "" ? null : (
						<span>, {objeto.correoTerciario}</span>
					)}
				</td>
				<td className='telefono' style={{ cursor: "copy" }}>
					{objeto.fono}
				</td>
				<td>{objeto.fechaContratacion}</td>
				<td>{objeto.dicom}</td>
				<td>{objeto.patente}</td>
				<td>{objeto.vigente}</td>
				{<td>${CalculoSaldo(objeto, false)}</td>}
			</tr>
		);
	};

	return (
		<div className={store.witch ? "" : "grid-x grid-margin-x"}>
			<button className='clear button alert' onClick={(e) => HandlerSaldo(e)}>
				Ver Algunos Datos
			</button>
			{panel && (
				<PanelInformativoDt
					array={array}
					setPanel={setPanel}
					tipoFiltro={tipoFiltro}
				/>
			)}
			{sessionStorage.getItem("listadoClientesDtProvidencia") != null ? (
				<table
					className={`table hover ${store.witch ? "tablaClientes" : ""}`}
					id='tblData'
				>
					<thead>
						<tr>
							<th className='id' scope='col'>
								Id
							</th>
							<th scope='col'>Razon Social</th>
							<th className='rut' scope='col'>
								Rut
							</th>
							<th scope='col'>Correo</th>
							<th className='telefono' scope='col'>
								Teléfono
							</th>
							<th className='fecha' scope='col'>
								Fecha
							</th>
							<th scope='col'>DICOM</th>
							<th scope='col'>Patente</th>
							<th scope='col'>Vigente</th>
							<th className='saldo' scope='col'>
								Saldo
							</th>
						</tr>
					</thead>
					<tbody>
						{sessionStorage.getItem("listadoClientesDtProvidencia") != null ? (
							JSON.parse(sessionStorage.getItem("listadoClientesDtProvidencia"))
								.filter((objeto) => Filtro(objeto))
								.map((objeto, i) => ListaDesplegarClientes(objeto, i))
						) : (
							<td colSpan='9' style={{ height: "100px", padding: "20px" }}>
								<h2 className='text-center'> - no hay datos -</h2>
							</td>
						)}
					</tbody>
				</table>
			) : null}
		</div>
	);
};

export default ListaClientesDtCompleta;


